import { useNavigate } from 'react-router-dom';

import { CampaignPeerSearchModal } from '../../../components';

const TeamsPage = () => {
  const navigate = useNavigate();
  return <CampaignPeerSearchModal opened={true} type="teams" onClose={() => navigate('..')} />;
};

export { TeamsPage };
